import { Button } from "@tellescope/ui";
import { formatName } from "@tellescope/utils";
import { Pencil, Trash2, User } from "lucide-react";
import { RelatedContactFormResult } from "./AddRelatedContactForm";

export interface RelatedContactProps {
  contact: RelatedContactFormResult;
  onEdit: () => void;
  onDelete: () => void;
}

export const RelatedContact = ({ contact, onEdit, onDelete }: RelatedContactProps) => {
  return (
    <div className="border flex justify-between rounded-md bg-gray-100 items-center py-1 px-3">
      <div className="flex gap-2 items-center">
        <User className="w-4" />
        <p className="text-sm">{formatName(contact)}</p>
      </div>
      <div className="flex items-center">
        <Button variant="ghost" size="icon" onClick={onEdit}>
          <Pencil />
        </Button>
        <Button variant="ghost" size="icon" onClick={onDelete}>
          <Trash2 />
        </Button>
      </div>
    </div>
  );
};
